module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/data_annotation_validation-c5bc92138c6ac68ba9ef86dbb3b69081.svg";